var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.00016,
    cy: 6.99976,
    r: 6.41813,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57326 5.56126C9.88657 5.24796 9.88657 4.73999 9.57326 4.42669C9.25996 4.11339 8.75199 4.11339 8.43869 4.42669L7.00031 5.86507L5.56194 4.42669C5.24863 4.11339 4.74067 4.11339 4.42736 4.42669C4.11406 4.73999 4.11406 5.24796 4.42736 5.56126L5.86574 6.99964L4.42736 8.43802C4.11406 8.75132 4.11406 9.25929 4.42736 9.57259C4.74067 9.8859 5.24863 9.8859 5.56194 9.57259L7.00031 8.13422L8.43869 9.57259C8.75199 9.8859 9.25996 9.8859 9.57326 9.57259C9.88657 9.25929 9.88657 8.75132 9.57326 8.43802L8.13489 6.99964L9.57326 5.56126Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CloseCircle.42ef0e4d22afa8640e1d794f0ab3e1c9.svg";